export default {
      id: "nav-usage",
      viewBox: "0 0 20 16",
      url: __webpack_public_path__ + "icons/symbols.67516b0a.svg#nav",
      toString: function () {
        return this.url;
      }
    }